import { BillingPlans } from "../data-access";

/**
 * Plan-based feature gating
 *
 * Max, Flex (+ Trial): everything available
 * Pro: everything except Auto Bidding
 * Lite: everything except Auto Bidding, CRM sync, Autocomplete, Manual Auto Bid
 */

export function canUseAutoBid(plan?: BillingPlans | string): boolean {
  const p = (plan || "").toLowerCase();
  return p === "max" || p === "flex" || p === "trial";
}

export function canUseCrm(plan?: BillingPlans | string): boolean {
  const p = (plan || "").toLowerCase();
  return p !== "lite";
}

/** Pro, Max, Flex, Trial can see bidding settings (templates, proposal config). Lite cannot. */
export function canUseBiddingSettings(plan?: BillingPlans | string): boolean {
  const p = (plan || "").toLowerCase();
  return p !== "lite";
}

/**
 * Plan name to show the user. Temporary: the backend still starts trials on
 * Max, but Flex is the only plan on sale, so a trial on Max is presented as
 * Flex. Remove once trials start on Flex server-side.
 */
export function getDisplayPlanName(plan?: string | null, billingStatus?: string | null): string | undefined {
  if (billingStatus === "trial" && (plan || "").toLowerCase() === "max") return "Flex";
  return plan || undefined;
}
